(function() {
    	/**
	 * Render Cookie page
	 * @param {object} props - The Routing context
	 * @returns {object} Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderCookiePage = function(props) {
		var $el = $('<div />');
		var params = {
			page: null,
			cookie: null
		};
		var model = {
			element: $('<div />'),
			template: 'templates/cookie-form.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				lang: WebBaseAprovLV.lang,
				cookie: null
			}
		};
		return WebBaseAprovLV.renderGenericPage(props).then(function(modelGeneric) {
			model.data = $.extend({}, modelGeneric.data, model.data);
			params.page = modelGeneric;
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).then(function(modelCookie) {
			$('#content .content_section').append(modelCookie.element);
			return modelCookie || {};
		}).promise();
	};

})();
